import { render, staticRenderFns } from "./ModalAssinaturaEletronicaGenerico.vue?vue&type=template&id=ed9de962&scoped=true"
import script from "./ModalAssinaturaEletronicaGenerico.vue?vue&type=script&lang=js"
export * from "./ModalAssinaturaEletronicaGenerico.vue?vue&type=script&lang=js"
import style0 from "./ModalAssinaturaEletronicaGenerico.vue?vue&type=style&index=0&id=ed9de962&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9de962",
  null
  
)

export default component.exports